import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";
import { IconButton, Link, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { TICKET_CATEGORIES_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import TicketCategoryForm from "./TicketCategoryForm";

function TicketCategoryDialog({
  editCategoryId = "",
  categoryName,
  variant = "button", // 'button' for add, 'link' for edit
}) {
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClickOpen = async () => {
    if (editCategoryId && editCategoryId !== "") {
      setLoading(true);
      try {
        const response = await AxiosInstance.get(
          `${TICKET_CATEGORIES_URL}/${editCategoryId}`
        );
        setEditData(response.data);
        setOpen(true);
      } catch (error) {
        console.error("Error fetching category:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setEditData(null);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditData(null);
  };

  const renderTrigger = () => {
    if (variant === "link" && editCategoryId) {
      return (
        <Link
          component="button"
          onClick={handleClickOpen}
          disabled={loading}
          sx={{
            cursor: "pointer",
            textDecoration: "none",
            color: "primary.main",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {categoryName}
        </Link>
      );
    }

    return (
      <Tooltip
        title="Add New Category"
        onClick={handleClickOpen}
        disabled={loading}
      >
        <IconButton
          sx={{
            cursor: "pointer",
            margin: "2px",
            color: (theme) => theme.palette.grey[500],
            borderRadius: 2,
            border: 1,
            borderColor: "divider",
          }}
        >
          <AddTaskOutlinedIcon color="primary" />
        </IconButton>
      </Tooltip>
    );
  };

  return (
    <>
    { renderTrigger() }
    < TicketCategoryForm
        open= { open }
  onClose = { handleClose }
  editData = { editData }
  isEditMode = { Boolean(editData) }
    />
    </>
  );
}
export default TicketCategoryDialog;
